import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import Cookies from "universal-cookie";
import styled from "styled-components";
import * as Styles from "../../Farmers/components/FarmerForm/style";
import close from "../../assets/images/close.png";

const TableContainer = styled.div`
  width: 95%;
  margin: 20px auto;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  overflow-x: auto;
  border: 1px solid #eaeaea;
`;

const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  text-align: left;
  font-family: 'Inter', sans-serif;
`;

const Th = styled.th`
  background-color: #f8f9fa;
  color: #EF5A20;
  font-weight: 600;
  font-size: 14px;
  padding: 16px 20px;
  border-bottom: 2px solid #eaeaea;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

const Td = styled.td`
  padding: 16px 20px;
  border-bottom: 1px solid #f0f0f0;
  color: #262626;
  font-size: 14px;
  vertical-align: middle;
`;

const Tr = styled.tr`
  transition: background-color 0.2s ease;
  &:hover {
    background-color: #f9f9f9;
  }
`;

const ViewButton = styled.button`
  background-color: #EF5A20;
  color: #ffffff;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background-color: #d44e1c;
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(239, 90, 32, 0.2);
  }

  &:active {
    transform: translateY(0);
  }
`;

const cookies = new Cookies();
const token = cookies.get("access_token");

const parseArrayField = (val) => {
  if (!val) return [];
  const resolveValue = (v) => {
    if (typeof v === 'string' && v.trim().startsWith('[')) {
      try {
        const parsed = JSON.parse(v);
        return resolveValue(parsed);
      } catch (e) {
        const cleaned = v.replace(/[\[\]"]/g, '').trim();
        return cleaned ? [cleaned] : [];
      }
    }
    if (Array.isArray(v)) {
      return v.flatMap(item => resolveValue(item));
    }
    return [v];
  };
  const flatResult = resolveValue(val);
  return flatResult
    .map(x => typeof x === 'string' ? x.trim() : String(x))
    .filter(x => x && x !== 'null' && x !== 'undefined' && x !== 'N/A' && x !== '[""]' && x !== '[]');
};

const formatDateTime = (dateString) => {
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return dateString;
  const dateOptions = { day: "2-digit", month: "long", year: "numeric" };
  const timeOptions = { hour: "2-digit", minute: "2-digit", hour12: true };
  const formattedDate = date.toLocaleDateString("en-GB", dateOptions);
  const formattedTime = date.toLocaleTimeString("en-GB", timeOptions);
  return `${formattedDate} at ${formattedTime}`;
};

const renderLoggedBy = (logData, apiary) => {
  const userName = logData.userName;
  const beekeeperId = apiary?.beekeeper_id;
  const isSelf = logData.created_by && beekeeperId && logData.created_by.toString() === beekeeperId.toString();
  
  if (userName) {
    const name = userName.name || (isSelf ? "Self" : "Bee-mitra");
    const phone = userName.mobileNumber || userName.mobile;
    if (phone) {
      return (
        <span>
          {isSelf ? "Self" : "Bee-mitra"} (
          <a
            href={`https://api.whatsapp.com/send?phone=91${phone}`}
            target="_blank"
            rel="noreferrer"
            onClick={(e) => e.stopPropagation()}
            style={{ color: "#EF5A20", textDecoration: "underline", fontWeight: "600" }}
          >
            {name} - {phone}
          </a>
          )
        </span>
      );
    }
    return <span>{isSelf ? "Self" : "Bee-mitra"} ({name})</span>;
  }
  
  return <span>{isSelf ? "Self" : "Bee-mitra"}</span>;
};

const renderStatusBadge = (val) => {
  const isYes = val === 'yes' || val === 'YES' || val === true || val === 'Yes' || val === '✓';
  return (
    <span style={{
      display: 'inline-block',
      padding: '4px 10px',
      borderRadius: '20px',
      fontSize: '12px',
      fontWeight: '600',
      textTransform: 'uppercase',
      backgroundColor: isYes ? '#E6F4EA' : '#F1F3F4',
      color: isYes ? '#137333' : '#5F6368',
      border: `1px solid ${isYes ? '#CEEAD6' : '#DADCE0'}`
    }}>
      {isYes ? '✓ Yes' : '✗ No'}
    </span>
  );
};

const renderSeverityBadge = (severity) => {
  if (!severity) return <span style={{ color: '#999' }}>—</span>;
  const sev = severity.toUpperCase();
  let bg = '#F1F3F4', fg = '#5F6368', border = '#DADCE0';
  if (sev === 'LOW') { bg = '#FEF7E0'; fg = '#B06000'; border = '#FEEFC3'; }
  else if (sev === 'MEDIUM') { bg = '#FEEFC3'; fg = '#C26401'; border = '#FFE082'; }
  else if (sev === 'HIGH') { bg = '#FAD2E1'; fg = '#A71C49'; border = '#F8B4D9'; }
  
  return (
    <span style={{
      display: 'inline-block',
      padding: '4px 10px',
      borderRadius: '20px',
      fontSize: '12px',
      fontWeight: '600',
      textTransform: 'uppercase',
      backgroundColor: bg,
      color: fg,
      border: `1px solid ${border}`
    }}>
      {severity}
    </span>
  );
};

const renderRatingBadge = (rating) => {
  if (!rating) return <span style={{ color: '#999' }}>—</span>;
  const r = rating.toUpperCase();
  let bg = '#F1F3F4', fg = '#5F6368', border = '#DADCE0';
  if (r === 'GOOD' || r === 'YES') { bg = '#E6F4EA'; fg = '#137333'; border = '#CEEAD6'; }
  else if (r === 'AVERAGE' || r === 'MODERATE') { bg = '#FEF7E0'; fg = '#B06000'; border = '#FEEFC3'; }
  else if (r === 'POOR' || r === 'NO') { bg = '#FCE8E6'; fg = '#C5221F'; border = '#FAD2E1'; }

  return (
    <span style={{
      display: 'inline-block',
      padding: '4px 10px',
      borderRadius: '20px',
      fontSize: '12px',
      fontWeight: '600',
      textTransform: 'uppercase',
      backgroundColor: bg,
      color: fg,
      border: `1px solid ${border}`
    }}>
      {rating}
    </span>
  );
};

const SectionTitle = ({ children }) => (
  <h4 style={{
    color: '#EF5A20',
    fontSize: '18px',
    fontWeight: '700',
    marginTop: '25px',
    marginBottom: '12px',
    borderBottom: '2px solid #FEE5D9',
    paddingBottom: '6px'
  }}>
    {children}
  </h4>
);

const renderScientificInspectionReport = (data, userData) => {
  const si = data.scientific_inspection || {};
  const gi = si.general_info || {};
  const cd = si.colony_details || {};
  const weakReasons = si.weak_colonies_reasons || {};
  const checklist = si.colony_checklist || {};
  const pests = si.pest_predator_observation || {};
  const diseases = si.disease_observation || {};
  const env = si.floral_environmental || {};
  const hm = si.hive_management || {};
  const suggestions = si.suggestions || {};
  const nextVisit = si.next_visit || {};
  const remarks = si.final_remarks_inspector || [];
  const photos = data.mediaUrls || data.apiary_photos || data.photos || [];

  return (
    <div style={{ fontFamily: 'Inter, sans-serif', color: '#262626', padding: '10px' }}>
      
      {/* 1. General Information */}
      <SectionTitle>General Information</SectionTitle>
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
        gap: '15px',
        backgroundColor: '#FAFAFA',
        padding: '16px',
        borderRadius: '8px',
        border: '1px solid #EAEAEA',
        marginBottom: '20px'
      }}>
        <div><strong>Date of Visit:</strong> {formatDateTime(data.created_at)}</div>
        <div><strong>Time of Inspection:</strong> {gi.time_of_inspection || 'N/A'}</div>
        <div><strong>Beekeeper Name:</strong> {userData?.name || 'N/A'}</div>
        <div><strong>Mobile Number:</strong> {userData?.mobileNumber || 'N/A'}</div>
        <div><strong>SHG / PG / Cluster Name:</strong> {gi.shg_pg_cluster_name || 'N/A'}</div>
        <div><strong>Village:</strong> {gi.village || 'N/A'}</div>
        <div><strong>Gram Panchayat:</strong> {gi.gram_panchayat || 'N/A'}</div>
        <div><strong>Block / Mandal:</strong> {gi.block_mandal || 'N/A'}</div>
        <div><strong>District:</strong> {gi.district || 'N/A'}</div>
        <div><strong>State:</strong> {gi.state || 'N/A'}</div>
        <div><strong>Bee-Mitra / Inspector Name:</strong> {gi.bee_mitra_inspector || 'N/A'}</div>
        <div><strong>Bee Species:</strong> {gi.bee_species || 'N/A'}</div>
        <div><strong>Photo Captured:</strong> {data.mediaUrls?.length > 0 ? 'Yes' : 'No'}</div>
      </div>

      {/* 2. Colony Details */}
      <SectionTitle>Colony Details</SectionTitle>
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))',
        gap: '12px',
        marginBottom: '20px'
      }}>
        {[
          { label: 'Total Colonies Available', val: cd.total_colonies_available },
          { label: 'Colonies Inspected', val: cd.number_of_colonies_inspected },
          { label: 'Active Colonies', val: cd.number_of_active_colonies },
          { label: 'Weak Colonies', val: cd.number_of_weak_colonies },
          { label: 'Inactive / Dead Colonies', val: cd.number_of_inactive_dead_colonies },
          { label: 'Migrated / Absconded', val: cd.number_of_absconded_colonies },
          { label: 'Queenless Colonies', val: cd.number_of_queenless_colonies },
        ].map((item, idx) => (
          <div key={idx} style={{
            backgroundColor: '#FAFAFA',
            border: '1px solid #EAEAEA',
            borderRadius: '8px',
            padding: '12px',
            textAlign: 'center',
            boxShadow: '0 2px 4px rgba(0,0,0,0.02)'
          }}>
            <div style={{ fontSize: '24px', fontWeight: 'bold', color: '#EF5A20' }}>{item.val ?? 0}</div>
            <div style={{ fontSize: '13px', color: '#666', marginTop: '4px' }}>{item.label}</div>
          </div>
        ))}
      </div>

      {/* 3. Reason for Inactive / Weak Colonies */}
      <SectionTitle>Reason for Inactive / Weak Colonies</SectionTitle>
      <div style={{
        backgroundColor: '#FAFAFA',
        padding: '16px',
        borderRadius: '8px',
        border: '1px solid #EAEAEA',
        marginBottom: '20px'
      }}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
          gap: '12px'
        }}>
          {[
            { key: 'absconding', label: 'Absconding' },
            { key: 'queen_loss', label: 'Queen Loss' },
            { key: 'lack_of_nectar', label: 'Lack of Nectar' },
            { key: 'lack_of_pollen', label: 'Lack of Pollen' },
            { key: 'pest_attack', label: 'Pest Attack' },
            { key: 'disease_symptoms', label: 'Disease Symptoms' },
            { key: 'starvation', label: 'Starvation' },
            { key: 'excess_heat', label: 'Excess Heat' },
            { key: 'rain_moisture_problem', label: 'Rain / Moisture Problem' },
            { key: 'pesticide_exposure', label: 'Pesticide Exposure' },
            { key: 'poor_hive_maintenance', label: 'Poor Hive Maintenance' },
            { key: 'old_damaged_comb', label: 'Old / Damaged Comb' },
            { key: 'ant_attack', label: 'Ant Attack' },
            { key: 'wax_moth_infestation', label: 'Wax Moth Infestation' },
            { key: 'colony_merging_required', label: 'Colony Merging Required' },
          ].map((item) => (
            <div key={item.key} style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '8px 12px',
              backgroundColor: '#FFF',
              border: '1px solid #EAEAEA',
              borderRadius: '6px'
            }}>
              <span>{item.label}</span>
              {renderStatusBadge(weakReasons[item.key])}
            </div>
          ))}
        </div>
        {si.weak_colonies_reasons_other_remarks ? (
          <div style={{ marginTop: '15px', padding: '12px', backgroundColor: '#FFF', borderRadius: '6px', border: '1px solid #EAEAEA' }}>
            <strong>Other Weakness Remarks:</strong> {si.weak_colonies_reasons_other_remarks}
          </div>
        ) : null}
      </div>

      {/* 4. Colony Inspection Checklist */}
      <SectionTitle>Colony Inspection Checklist (Colony Strength & Brood Status)</SectionTitle>
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
        gap: '12px',
        marginBottom: '20px'
      }}>
        {[
          { key: 'Queen Present', label: 'Queen Present' },
          { key: 'Fresh Eggs Seen', label: 'Fresh Eggs Seen' },
          { key: 'Larvae Present', label: 'Larvae Present' },
          { key: 'Sealed Brood Present', label: 'Sealed Brood Present' },
          { key: 'Brood Pattern Healthy', label: 'Brood Pattern Healthy' },
          { key: 'Brood Pattern Unhealthy / Scattered', label: 'Brood Pattern Unhealthy / Scattered' },
          { key: 'Drone Brood Excessive', label: 'Drone Brood Excessive' },
          { key: 'Queen Cells Present', label: 'Queen Cells Present' },
          { key: 'Worker Laying Symptoms', label: 'Worker Laying Symptoms' },
          { key: 'Colony Population Strong', label: 'Colony Population Strong' },
          { key: 'Honey Storage Adequate', label: 'Honey Storage Adequate' },
          { key: 'Pollen Storage Adequate', label: 'Pollen Storage Adequate' },
        ].map((item) => (
          <div key={item.key} style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '10px 16px',
            backgroundColor: '#FAFAFA',
            border: '1px solid #EAEAEA',
            borderRadius: '6px'
          }}>
            <span>{item.label}</span>
            {renderStatusBadge(checklist[item.key])}
          </div>
        ))}
      </div>

      {/* 5. Pest & Predator Observation */}
      <SectionTitle>Pest & Predator Observation</SectionTitle>
      <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '20px' }}>
        <thead>
          <tr style={{ backgroundColor: '#F8F9FA' }}>
            <th style={{ padding: '12px', borderBottom: '2px solid #EAEAEA', textAlign: 'left' }}>Pest / Predator</th>
            <th style={{ padding: '12px', borderBottom: '2px solid #EAEAEA', textAlign: 'center' }}>Observed</th>
            <th style={{ padding: '12px', borderBottom: '2px solid #EAEAEA', textAlign: 'center' }}>Severity</th>
            <th style={{ padding: '12px', borderBottom: '2px solid #EAEAEA', textAlign: 'left' }}>Remarks</th>
          </tr>
        </thead>
        <tbody>
          {[
            'Ants', 'Cockroaches', 'Wax Moth', 'Spider Webs', 'Lizards',
            'Birds / Bee Eaters', 'Wasps / Hornets', 'Termites', 'Rats / Rodents',
            'Small Hive Beetle', 'Frogs'
          ].map((pest) => {
            const obs = pests[pest] || { observed: 'no', severity: 'Low', remarks: '' };
            return (
              <tr key={pest} style={{ borderBottom: '1px solid #F0F0F0' }}>
                <td style={{ padding: '12px' }}><strong>{pest}</strong></td>
                <td style={{ padding: '12px', textAlign: 'center' }}>{renderStatusBadge(obs.observed)}</td>
                <td style={{ padding: '12px', textAlign: 'center' }}>{renderSeverityBadge(obs.severity)}</td>
                <td style={{ padding: '12px', color: '#666' }}>{obs.remarks || '—'}</td>
              </tr>
            );
          })}
        </tbody>
      </table>

      {/* 6. Disease Observation */}
      <SectionTitle>Disease Observation</SectionTitle>
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
        gap: '12px',
        marginBottom: '20px'
      }}>
        {[
          { key: 'Foul Smell from Brood', label: 'Foul Smell from Brood' },
          { key: 'Chalk Brood Symptoms', label: 'Chalk Brood Symptoms' },
          { key: 'Sac Brood Symptoms', label: 'Sac Brood Symptoms' },
          { key: 'Deformed Bees', label: 'Deformed Bees' },
          { key: 'Dead Brood Seen', label: 'Dead Brood Seen' },
          { key: 'Mold / Fungal Growth', label: 'Mold / Fungal Growth' },
          { key: 'Dysentery Symptoms', label: 'Dysentery Symptoms' },
          { key: 'Other Disease Symptoms', label: 'Other Disease Symptoms' },
        ].map((item) => (
          <div key={item.key} style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '10px 16px',
            backgroundColor: '#FAFAFA',
            border: '1px solid #EAEAEA',
            borderRadius: '6px'
          }}>
            <span>{item.label}</span>
            {renderStatusBadge(diseases[item.key])}
          </div>
        ))}
      </div>

      {/* 7. Floral & Environmental Condition */}
      <SectionTitle>Floral & Environmental Condition</SectionTitle>
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
        gap: '15px',
        backgroundColor: '#FAFAFA',
        padding: '16px',
        borderRadius: '8px',
        border: '1px solid #EAEAEA',
        marginBottom: '20px'
      }}>
        <div><strong>Major Flowering Crops Nearby:</strong> {env.flowering_crops_nearby || 'N/A'}</div>
        <div><strong>Nectar Availability:</strong> {renderRatingBadge(env.nectar_availability)}</div>
        <div><strong>Pollen Availability:</strong> {renderRatingBadge(env.pollen_availability)}</div>
        <div><strong>Water Source Available Nearby:</strong> {renderRatingBadge(env.water_source_nearby)}</div>
        <div><strong>Shade Availability:</strong> {renderRatingBadge(env.shade_availability)}</div>
        <div><strong>Pesticide Spraying Nearby:</strong> {renderRatingBadge(env.pesticide_spraying_nearby)}</div>
        <div><strong>Weather Condition During Visit:</strong> {env.weather_condition || 'N/A'}</div>
        <div><strong>Migration Required:</strong> {renderRatingBadge(env.migration_required)}</div>
      </div>

      {/* 8. Hive Management Condition */}
      <SectionTitle>Hive Management Condition</SectionTitle>
      <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '20px' }}>
        <thead>
          <tr style={{ backgroundColor: '#F8F9FA' }}>
            <th style={{ padding: '12px', borderBottom: '2px solid #EAEAEA', textAlign: 'left' }}>Inspection Point</th>
            <th style={{ padding: '12px', borderBottom: '2px solid #EAEAEA', textAlign: 'center' }}>Rating</th>
            <th style={{ padding: '12px', borderBottom: '2px solid #EAEAEA', textAlign: 'left' }}>Remarks</th>
          </tr>
        </thead>
        <tbody>
          {[
            { key: 'cleanliness', label: 'Hive Cleanliness' },
            { key: 'bottom_board', label: 'Bottom Board Condition' },
            { key: 'frame_condition', label: 'Frame Condition' },
            { key: 'comb_condition', label: 'Comb Condition' },
            { key: 'hive_stand', label: 'Hive Stand Condition' },
            { key: 'protection_from_ants', label: 'Protection from Ants' },
            { key: 'ventilation', label: 'Ventilation' },
            { key: 'shade_arrangement', label: 'Shade Arrangement' },
            { key: 'water_arrangement', label: 'Water Arrangement' }
          ].map((item) => {
            const val = hm[item.key] || { rating: 'good', remarks: '' };
            return (
              <tr key={item.key} style={{ borderBottom: '1px solid #F0F0F0' }}>
                <td style={{ padding: '12px' }}><strong>{item.label}</strong></td>
                <td style={{ padding: '12px', textAlign: 'center' }}>{renderRatingBadge(val.rating)}</td>
                <td style={{ padding: '12px', color: '#666' }}>{val.remarks || '—'}</td>
              </tr>
            );
          })}
        </tbody>
      </table>

      {/* 9. Suggestions / Advisory Given */}
      <SectionTitle>Suggestions / Advisory Given to Beekeeper</SectionTitle>
      <div style={{
        backgroundColor: '#FAFAFA',
        padding: '16px',
        borderRadius: '8px',
        border: '1px solid #EAEAEA',
        marginBottom: '20px'
      }}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
          gap: '10px',
          marginBottom: '15px'
        }}>
          {[
            { key: 'sugar_syrup_feeding', label: 'Sugar Syrup Feeding' },
            { key: 'pollen_patty_feeding', label: 'Pollen Patty Feeding' },
            { key: 'regular_hive_inspection', label: 'Regular Hive Inspection' },
            { key: 'deep_cleaning_hive', label: 'Deep Cleaning of Hive' },
            { key: 'wax_moth_control', label: 'Wax Moth Control' },
            { key: 'ant_protection', label: 'Ant Protection Measures' },
            { key: 'comb_replacement', label: 'Comb Replacement' },
            { key: 'colony_strengthening', label: 'Colony Strengthening' },
            { key: 'colony_merging', label: 'Colony Merging' },
            { key: 'queen_replacement', label: 'Queen Replacement' },
            { key: 'hive_shifting_migration', label: 'Hive Shifting / Migration' },
            { key: 'provide_shade', label: 'Provide Shade' },
            { key: 'provide_water_source', label: 'Provide Water Source' },
            { key: 'pest_monitoring', label: 'Pest Monitoring' },
            { key: 'honey_super_addition', label: 'Honey Super Addition' },
            { key: 'honey_harvesting_guidance', label: 'Honey Harvesting Guidance' },
            { key: 'swarm_prevention', label: 'Swarm Prevention Measures' },
            { key: 'record_keeping', label: 'Record Keeping Guidance' }
          ].map((item) => (
            <div key={item.key} style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '8px 12px',
              backgroundColor: '#FFF',
              border: '1px solid #EAEAEA',
              borderRadius: '6px'
            }}>
              <span>{item.label}</span>
              {renderStatusBadge(suggestions[item.key])}
            </div>
          ))}
        </div>
        {si.suggestions_details_remarks ? (
          <div style={{ padding: '12px', backgroundColor: '#FFF', borderRadius: '6px', border: '1px solid #EAEAEA' }}>
            <strong>Details of Suggestions:</strong>
            <p style={{ margin: '8px 0 0 0', whiteSpace: 'pre-line', color: '#444' }}>
              {si.suggestions_details_remarks}
            </p>
          </div>
        ) : null}
      </div>

      {/* 10. Next Visit Plan */}
      <SectionTitle>Next Visit Plan</SectionTitle>
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
        gap: '15px',
        backgroundColor: '#FAFAFA',
        padding: '16px',
        borderRadius: '8px',
        border: '1px solid #EAEAEA',
        marginBottom: '20px'
      }}>
        <div><strong>Proposed Date of Next Visit:</strong> {nextVisit.proposed_date ? new Date(nextVisit.proposed_date).toLocaleDateString("en-GB") : 'N/A'}</div>
        <div><strong>Purpose of Next Visit:</strong> {nextVisit.purpose || 'N/A'}</div>
        <div><strong>Follow-up Required:</strong> {renderStatusBadge(nextVisit.follow_up_required)}</div>
      </div>

      {/* 11. Final Remarks of Inspector */}
      {remarks && remarks.length > 0 ? (
        <>
          <SectionTitle>Final Remarks of Inspector</SectionTitle>
          <div style={{
            backgroundColor: '#FAFAFA',
            padding: '16px',
            borderRadius: '8px',
            border: '1px solid #EAEAEA',
            marginBottom: '20px'
          }}>
            <ul style={{ margin: 0, paddingLeft: '20px' }}>
              {remarks.map((r, index) => (
                <li key={index} style={{ marginBottom: '8px', fontSize: '15px' }}>{r}</li>
              ))}
            </ul>
          </div>
        </>
      ) : null}

      {/* 12. Media/Photos */}
      {data.mediaUrls?.length > 0 ? (
        <>
          <SectionTitle>Photos Captured</SectionTitle>
          <div style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: '15px',
            marginTop: '10px'
          }}>
            {data.mediaUrls.map((url, idx) => (
              <img
                key={url || idx}
                src={url}
                alt={`inspection-${idx}`}
                style={{
                  width: '260px',
                  height: '200px',
                  objectFit: 'cover',
                  borderRadius: '6px',
                  border: '1px solid #DDD'
                }}
              />
            ))}
          </div>
        </>
      ) : null}

    </div>
  );
};

const Modal = ({ onClose, data, apiaryData, userData }) => {
  const handleClose = () => {
    onClose();
  };
  return (
    <>
      <Styles.ModalWrapper>
        <Styles.ModalContent2 style={{ maxHeight: '90vh', overflow: 'hidden', display: 'flex', flexDirection: 'column', borderRadius: '8px', width: '70vw' }}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              boxShadow:
                "rgba(67, 71, 85, 0.27) 0px 0px 0.25em,rgba(90, 125, 188, 0.05) 0px 0.25em 1em",
              padding: 20,
              width: "100%",
              overflowY: "auto",
              maxHeight: "100%",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                paddingBottom: 10,
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "4px"
                }}
              >
                <h3 style={{ margin: 0, fontSize: "20px", color: "#EF5A20" }}>
                  {data.scientific_inspection ? "Scientific Beekeeping Colony Inspection Report" : `Activity On ${formatDateTime(data.created_at)}`}
                </h3>
                <p style={{ margin: 0, fontSize: "15px", color: "#262626" }}>
                  Logged By: {renderLoggedBy(data, apiaryData)}
                </p>
                {data.latitude && data.longitude ? (
                  <p style={{ margin: 0, fontSize: "14px", color: "#666" }}>
                    Location:{" "}
                    <a
                      href={`https://www.google.com/maps/search/?api=1&query=${data.latitude},${data.longitude}`}
                      target="_blank"
                      rel="noreferrer"
                      style={{ color: "#EF5A20", textDecoration: "underline", fontWeight: "600" }}
                    >
                      {data.latitude}, {data.longitude}
                    </a>
                  </p>
                ) : null}
              </div>
              <div style={{
                cursor:'pointer'
              }} onClick={handleClose}>
                <img
                  style={{
                    width: 20,
                    height: 20,
                  }}
                  onClick={handleClose}
                  src={close}
                  alt="Close"
                />
              </div>
            </div>

            {/* Main Bode of Form Starts */}
            {data.scientific_inspection ? (
              renderScientificInspectionReport(data, userData)
            ) : (
              <Styles.MainFarmerFormDiv2>
                <Styles.RowFlex>
                  <div>
                    <p
                      style={{
                        fontSize: 20,
                        fontWeight: "600",
                        color: "#262626",
                        marginBottom: 5,
                      }}
                    >
                      Hive Health
                    </p>

                    <p
                      style={{
                        fontSize: 18,
                        marginBottom: 0,
                        fontWeight: "400",
                        color: "#262626",
                      }}
                    >
                      1. Number of strong colonies:{" "}
                      <span
                        style={{
                          fontSize: 18,
                          fontWeight: "600",
                          color: "#262626",
                        }}
                      >
                        {data.observation.number_of_strong_colonies}
                      </span>
                    </p>
                    <p
                      style={{
                        fontSize: 18,
                        marginBottom: 0,
                        fontWeight: "400",
                        color: "#262626",
                      }}
                    >
                      2. Number of weak colonies:{" "}
                      <span
                        style={{
                          fontSize: 18,
                          fontWeight: "600",
                          color: "#262626",
                        }}
                      >
                        {data.observation.number_of_weak_colonies}
                      </span>
                    </p>
                    <p
                      style={{
                        fontSize: 18,
                        marginBottom: 0,
                        fontWeight: "400",
                        color: "#262626",
                      }}
                    >
                      3. Number of colonies without queen:{" "}
                      <span
                        style={{
                          fontSize: 18,
                          fontWeight: "600",
                          color: "#262626",
                        }}
                      >
                        {data.observation.number_of_colonies_without_queen}
                      </span>
                    </p>
                    <p
                      style={{
                        fontSize: 18,
                        marginBottom: 0,
                        fontWeight: "400",
                        color: "#262626",
                      }}
                    >
                      4. Number of colonies with pests:{" "}
                      <span
                        style={{
                          fontSize: 18,
                          fontWeight: "600",
                          color: "#262626",
                        }}
                      >
                        {data.observation.number_of_colonies_with_pests}
                      </span>
                    </p>
                    <p
                      style={{
                        fontSize: 18,
                        marginBottom: 0,
                        fontWeight: "400",
                        color: "#262626",
                      }}
                    >
                      5. Number of colonies with diseases:{" "}
                      <span
                        style={{
                          fontSize: 18,
                          fontWeight: "600",
                          color: "#262626",
                        }}
                      >
                        {data.observation.number_of_colonies_with_diseases}
                      </span>
                    </p>
                    <p
                      style={{
                        fontSize: 18,
                        marginBottom: 0,
                        fontWeight: "400",
                        color: "#262626",
                      }}
                    >
                      6. Cleanliness of hives:{" "}
                      <span
                        style={{
                          fontSize: 18,
                          fontWeight: "600",
                          color: "#262626",
                        }}
                      >
                        {data.observation.cleanliness_of_hives}
                      </span>
                    </p>
                    <p
                      style={{
                        fontSize: 18,
                        marginBottom: 0,
                        fontWeight: "400",
                        color: "#262626",
                      }}
                    >
                      7. Condition of boxes:{" "}
                      <span
                        style={{
                          fontSize: 18,
                          fontWeight: "600",
                          color: "#262626",
                        }}
                      >
                        {data.observation.condition_of_beeboxes}
                      </span>
                    </p>
                    <p
                      style={{
                        fontSize: 18,
                        marginBottom: 0,
                        fontWeight: "400",
                        color: "#262626",
                      }}
                    >
                      8. Availability of flowers:{" "}
                      <span
                        style={{
                          fontSize: 18,
                          fontWeight: "600",
                          color: "#262626",
                        }}
                      >
                        {data.observation.availability_of_flowers}
                      </span>
                    </p>
                  </div>
                  <div
                    style={{
                      width: 1,
                      background: "#CBCBCB",
                      height: 200,
                    }}
                  />
                  <div>
                    <p
                      style={{
                        fontSize: 20,
                        fontWeight: "600",
                        color: "#262626",
                        marginBottom: 5,
                      }}
                    >
                      Activities done
                    </p>

                    {[
                      { label: "Colony", key: "colony" },
                      { label: "Environment", key: "environment" },
                      { label: "Feeding", key: "feeding" },
                      { label: "Harvesting", key: "harvesting" },
                      { label: "Hive Related", key: "hive_related" },
                    ].map(({ label, key }, index) => (
                      <p
                        key={index}
                        style={{
                          fontSize: 18,
                          marginBottom: 0,
                          fontWeight: "400",
                          color: "#262626",
                        }}
                      >
                        {index + 1}. {label}:{" "}
                        <span
                          style={{
                            fontSize: 18,
                            fontWeight: "600",
                            color: "#262626",
                          }}
                        >
                          {(() => {
                            const parsed = parseArrayField(data.activities_performed_during_visit?.[key]);
                            return parsed.length ? parsed.join(", ") : "None";
                          })()}
                        </span>
                      </p>
                    ))}
                  </div>

                  <div
                    style={{
                      width: 1,
                      background: "#CBCBCB",
                      height: 200,
                    }}
                  />

                  <div>
                    <p
                      style={{
                        fontSize: 20,
                        fontWeight: "600",
                        color: "#262626",
                        marginBottom: 5,
                      }}
                    >
                      Planned Activities
                    </p>

                    {[
                      { label: "Colony", key: "activities_recommended_colony" },
                      {
                        label: "Environment",
                        key: "activities_recommended_environment",
                      },
                      { label: "Feeding", key: "activities_recommended_feeding" },
                      {
                        label: "Harvesting",
                        key: "activities_recommended_harvesting",
                      },
                      {
                        label: "Hive Related",
                        key: "activities_recommended_hive_related",
                      },
                    ].map(({ label, key }, index) => (
                      <p
                        key={index}
                        style={{
                          fontSize: 18,
                          marginBottom: 0,
                          fontWeight: "400",
                          color: "#262626",
                        }}
                      >
                        {index + 1}. {label}:{" "}
                        <span
                          style={{
                            fontSize: 18,
                            fontWeight: "600",
                            color: "#262626",
                          }}
                        >
                          {(() => {
                            const parsed = parseArrayField(data.activities_recommended_for_beekeeper?.[key]);
                            return parsed.length ? parsed.join(", ") : "None";
                          })()}
                        </span>
                      </p>
                    ))}
                  </div>
                </Styles.RowFlex>
                {data.mediaUrls?.length > 0 && (
                  <p
                    style={{
                      marginTop: 15,
                      fontSize: 20,
                      fontWeight: "600",
                      color: "#262626",
                    }}
                  >
                    Images
                  </p>
                )}
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    flexWrap: "wrap",
                    alignItems: "center",
                  }}
                >
                  {data.mediaUrls?.length > 0 &&
                    data.mediaUrls.map((it) => (
                      <img src={it} style={{ width: 338, height: 270 }} />
                    ))}
                </div>
              </Styles.MainFarmerFormDiv2>
            )}
          </div>
        </Styles.ModalContent2>
      </Styles.ModalWrapper>
    </>
  );
};
export const ApiaryActivity = ({ apiaryData, userData }) => {
  const [apiaryActivityLog, setapiaryActivityLog] = useState(false);
  const [selectedIndex, setselectedIndex] = useState(-1);
  const [loading, setloading] = useState(true)
  const getapiaryActivityLog = async () => {
    try {
      const apiaryId = apiaryData[0]?._id || "";
      if (apiaryId == "") return;
      const config = {
        headers: {
          source: "HumblebeeWebApp",
          Authorization: "Bearer" + token,
        },
      };
      const res = await axios.get(
        `${process.env.REACT_APP_API_MENTOR_VAlUECHAIN_SERVICES}/hive-activity-log/${apiaryId}`,
        config
      );
      console.log(res.data.activities);
      setloading(false)
      setapiaryActivityLog(res.data.activities);
    } catch (error) {
      console.error("Error fetching activity logs:", error);
      setloading(false);
    }
  };
  useEffect(() => {
    getapiaryActivityLog();
  }, []);

  return (
    <>
      {loading ? (
        <p style={{ margin: "20px" }}>Loading ...</p>
      ) : apiaryActivityLog && apiaryActivityLog?.length > 0 ? (
        <TableContainer>
          <StyledTable>
            <thead>
              <tr>
                <Th>Date & Time</Th>
                <Th>Logged By</Th>
                <Th>Location</Th>
                <Th>Colonies (Strong/Weak)</Th>
                <Th>Pests/Diseases</Th>
                <Th>Action</Th>
              </tr>
            </thead>
            <tbody>
              {apiaryActivityLog.map((it, idx) => {
                return (
                  <Tr key={idx}>
                    <Td style={{ fontWeight: "600" }}>{formatDateTime(it.created_at)}</Td>
                    <Td>{renderLoggedBy(it, apiaryData[0])}</Td>
                    <Td>
                      {it.latitude && it.longitude ? (
                        <a
                          href={`https://www.google.com/maps/search/?api=1&query=${it.latitude},${it.longitude}`}
                          target="_blank"
                          rel="noreferrer"
                          onClick={(e) => e.stopPropagation()}
                          style={{ color: "#EF5A20", textDecoration: "underline", fontWeight: "600" }}
                        >
                          {it.latitude}, {it.longitude}
                        </a>
                      ) : (
                        <span style={{ color: "#999" }}>N/A</span>
                      )}
                    </Td>
                    <Td>
                      Strong: <strong>{it.scientific_inspection?.colony_details?.number_of_active_colonies ?? it.observation?.number_of_strong_colonies ?? 0}</strong> | Weak: <strong>{it.scientific_inspection?.colony_details?.number_of_weak_colonies ?? it.observation?.number_of_weak_colonies ?? 0}</strong>
                    </Td>
                    <Td>
                      Pests: <strong>{Object.keys(it.scientific_inspection?.pest_predator_observation || {}).filter(k => it.scientific_inspection?.pest_predator_observation[k]?.observed === 'yes').length || it.observation?.number_of_colonies_with_pests || 0}</strong> | Diseases: <strong>{Object.keys(it.scientific_inspection?.disease_observation || {}).filter(k => it.scientific_inspection?.disease_observation[k]?.observed === 'yes').length || it.observation?.number_of_colonies_with_diseases || 0}</strong>
                    </Td>
                    <Td>
                      <ViewButton onClick={() => setselectedIndex(idx)}>
                        View Details
                      </ViewButton>
                    </Td>
                  </Tr>
                );
              })}
            </tbody>
          </StyledTable>
        </TableContainer>
      ) : (
        <p style={{ margin: "20px" }}>No activities found.</p>
      )}

      {selectedIndex !== -1 ? (
        <Modal
          data={apiaryActivityLog[selectedIndex]}
          onClose={() => setselectedIndex(-1)}
          apiaryData={apiaryData[0]}
          userData={userData}
        />
      ) : null}
    </>
  );
};
